/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccessRule from './AccessRule';
import AffectedMachine from './AffectedMachine';

/**
 * The AccessRuleGroup model module.
 * @module model/AccessRuleGroup
 * @version 0.0.1
 */
class AccessRuleGroup {
    /**
     * Constructs a new <code>AccessRuleGroup</code>.
     * @alias module:model/AccessRuleGroup
     */
    constructor() { 
        
        AccessRuleGroup.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccessRuleGroup</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccessRuleGroup} obj Optional instance to populate.
     * @return {module:model/AccessRuleGroup} The populated <code>AccessRuleGroup</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccessRuleGroup();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('rule_type')) {
                obj['rule_type'] = ApiClient.convertToType(data['rule_type'], 'String');
            }
            if (data.hasOwnProperty('access_rules')) {
                obj['access_rules'] = ApiClient.convertToType(data['access_rules'], [AccessRule]);
            }
            if (data.hasOwnProperty('affected_machines')) {
                obj['affected_machines'] = ApiClient.convertToType(data['affected_machines'], [AffectedMachine]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccessRuleGroup</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccessRuleGroup</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['rule_type'] && !(typeof data['rule_type'] === 'string' || data['rule_type'] instanceof String)) {
            throw new Error("Expected the field `rule_type` to be a primitive type in the JSON string but got " + data['rule_type']);
        }
        if (data['access_rules']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['access_rules'])) {
                throw new Error("Expected the field `access_rules` to be an array in the JSON data but got " + data['access_rules']);
            }
            // validate the optional field `access_rules` (array)
            for (const item of data['access_rules']) {
                AccessRule.validateJSON(item);
            };
        }
        if (data['affected_machines']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['affected_machines'])) {
                throw new Error("Expected the field `affected_machines` to be an array in the JSON data but got " + data['affected_machines']);
            }
            // validate the optional field `affected_machines` (array)
            for (const item of data['affected_machines']) {
                AffectedMachine.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} email
 */
AccessRuleGroup.prototype['email'] = undefined;

/**
 * @member {String} rule_type
 */
AccessRuleGroup.prototype['rule_type'] = undefined;

/**
 * @member {Array.<module:model/AccessRule>} access_rules
 */
AccessRuleGroup.prototype['access_rules'] = undefined;

/**
 * @member {Array.<module:model/AffectedMachine>} affected_machines
 */
AccessRuleGroup.prototype['affected_machines'] = undefined;






export default AccessRuleGroup;

